import styled from '@emotion/styled';
import { fontSize } from '@styles/globalStyles';
import { breakpoint } from '@styles/breakpoints';

export const Container = styled.div`
  width: 100%;
  background-color: #f7f7f8;
`;
export const Wrapper = styled.div`
  max-width: 860px;
  margin: 0 auto;
  padding: 20px 0 56px 0;

  h1 {
    margin: 30px 0 26px 0;
  }

  @media only screen and (max-width: 1350px) {
    padding: 20px 15px 56px 15px;
  }
`;

export const Informations = styled.div`
  display: flex;
  grid-column-gap: 48px;
  padding: 56px 0;
  margin-top: 56px;
  border-top: 1px solid #ccecf9;

  & div:first-of-type {
    font-weight: 600;
  }

  @media only screen and ${breakpoint.md} {
    display: block;
    margin: 42px 0 20px 0;

    & div:first-of-type {
      margin-bottom: 16px;
    }
  }
`;

export const Contacts = styled.div`
  width: 50%;
  color: #00202d;
  font-size: ${fontSize(16)};
  line-height: 1.5;
  letter-spacing: -0.24px;

  @media only screen and ${breakpoint.md} {
    width: 100%;
  }
`;

export const ContactItem = styled.p`
  line-height: 1.5;
  letter-spacing: -0.24px;
  color: #00202d;
`;
export const EmailItem = styled.a`
  display: block;
  line-height: 1.5;
  letter-spacing: -0.24px;
  text-decoration: none;
  color: #00202d;
`;
